import Axios from "@/plugins/Axios";
import store from "@/store";
import ProfissionalDeApoio from "@/Models/ProfissionalDeApoio";

export class ProfissionaisDeApoioService {
  async syncAll() {
    const response = await Axios().get("profissionaisDeApoio");
    const profissionaisDeApoio = response.data.map(
      (profissionaisDeApoio) => new ProfissionalDeApoio(profissionaisDeApoio)
    );
    // store.commit("Professores/setProfessores", professores);
    return profissionaisDeApoio;
  }

  async show(profissional_de_apoio_id) {
    const response = await Axios().get(`profissionaisDeApoio/show/${profissional_de_apoio_id}`);
    return response;
  }

  async syncAllPaginate(pageNumber = 0, query = "") {
    const response = await Axios().get(
      `profissionaisDeApoio/paginate?page=${pageNumber}&query=${query}`
    );
    return response;
  }

  async criarProfissionalDeApoio(ProfissionalDeApoio) {
    const response = await Axios().post("profissionaisDeApoio", ProfissionalDeApoio);
    const novaProfissional = response.data;
    // store.commit("Professores/ProfissionaisDeApoio", novaProfissional);
    return novaProfissional;
  }

  async atualizarProfissionalDeApoio(ProfissionalDeApoio) {
    const response = await Axios().put(
      `profissionaisDeApoio/${ProfissionalDeApoio.id}`,
      ProfissionalDeApoio
    );
    const professorAtualizada = response.data;
    // store.commit("Professores/atualizarProfessor", professorAtualizada);
    return professorAtualizada;
  }

  async deletarProfissionalDeApoio(ProfissionalDeApoio) {
    const response = await Axios().delete(`profissionaisDeApoio/${ProfissionalDeApoio.id}`);
    const professorDeletada = response.data;
    // store.commit("Professores/deletarProfessor", professor.id);
    return professorDeletada;
  }

  async recuperarProfissionalDeApoio(profissionalDeApoio) {
    return this.atualizarProfissionalDeApoio({ ...profissionalDeApoio, deleted_at: null });
  }

  async grausAcademicos() {
    const response = await Axios().get("profissionaisDeApoio/graus-academicos");
    return response.data;
  }
}
export default new ProfissionaisDeApoioService();
